import React from 'react';
// import './loader.scss';

const Loader = ({ loading }) => {
  return loading ? <div className="loading">
    <div className="lds-facebook"><div></div><div></div><div></div></div>
  </div> : null
}

export default Loader;
